import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./app.scss";
import "./assets/css/rino.scss"
import Directive from "@/utils/directive"
import filters from "@/utils/filters"
import * as utils from "@/utils/utils"
import "video.js/dist/video-js.css"; // 引入video.js的css
import hls from "videojs-contrib-hls"; // 播放hls流需要的插件
Vue.use(hls);
import Upload from '@/components/uploads';
Vue.use(Upload);

//cookie插件
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
Vue.use(filters);
Vue.use(ElementUI);
Vue.use(Directive)

Vue.filter("learningStyle", function(value) {
    let result = "";
    switch (value) {
        case "COURSEWARE":
            result = "课件";
            break;
        case "LIVE":
            result = "直播";
            break;
        case "FACE":
            result = "面授";
    }
    return result;
});

Vue.config.productionTip = false;
Vue.prototype.utils = utils
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");